module.exports = __webpack_public_path__ + "static/media/info.843e359e.svg";